import React, { createContext, useState } from "react";

import { Customer } from "../models/customer";
import { CustomerType } from "../util/enums";
import { formatInTimeZone } from "../util/formatInTimezone";
import { getFullNameCustomer } from "../util/getFullNameCustomer";
import { useAppState } from "./StateContext";

interface CustomerContextProps {
  customer: Customer;
  setCustomer: (value: Customer) => void;
  handleUpdateCustomer: (attribute: string, value: any) => void;
}

const CustomerContext = createContext<CustomerContextProps>({} as CustomerContextProps);

interface CustomerProviderProps {
  children: React.ReactChild;
}

const CustomerProvider = ({ children }: CustomerProviderProps) => {
  const { currentUser, isFMorSPVersion } = useAppState();

  const [customer, setCustomer] = useState<Customer>({
    type: isFMorSPVersion ? CustomerType.CORPORATE : CustomerType.PRIVATE,
    status: "Active",
    companyId: currentUser?.companyId,
    since: formatInTimeZone("yyyy-MM-dd", "UTC", new Date()),
  } as Customer);

  const handleUpdateCustomer = (attribute: string, value: any) => {
    setCustomer((state: any) => ({
      ...state,
      [attribute]: value,
      fullName: getFullNameCustomer({ ...state, [attribute]: value, fullName: undefined }),
    }));
  };

  return (
    <CustomerContext.Provider
      value={{
        customer,
        setCustomer,
        handleUpdateCustomer,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export { CustomerContext, CustomerProvider };
